module.exports = __webpack_public_path__ + "static/img/about_zhuzq03.c56c36e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_zhuzq03.png
// module id = wkZ8
// module chunks = 1